export const state = {
  permissions: []
}

export default state
